import { FC, ReactElement, useEffect, useState } from 'react'
import { Form } from 'react-bootstrap'

export enum LocationType {
  Standaard = 'Standaard',
  Dag = 'Dag',
}

interface IProps {
  locationType: LocationType | string
  isEditable: boolean
  onLocationTypeChanged: (newLocationType: LocationType | string) => void
}

const LocationTypeLink: FC<Partial<IProps>> = (
  props: Partial<IProps>
): ReactElement => {
  const [initLocationType, setInitLocationType] = useState<
    LocationType | string
  >()
  const [showType, setShowType] = useState(false)

  const setLocationType = (newValue: LocationType | string) => {
    if (props.onLocationTypeChanged) {
      props.onLocationTypeChanged(newValue)
    }
  }

  useEffect(() => {
    setInitLocationType(props.locationType)
    setShowType(true)
  }, [])

  /**
   * Assuming this component is being used in a table.
   */
  return (
    <tr className='border'>
      <td>
        <h5>Type koppeling</h5>
      </td>
      <td>
        {' '}
        {showType && (
          <Form>
            <Form.Group className='mb-3'>
              {!props.isEditable && (
                <Form.Control type='text' value={initLocationType} disabled />
              )}
              {props.isEditable && (
                <Form.Control
                  as='select'
                  onChange={e => setLocationType(e.target.value)}
                >
                  {Object.values(LocationType).map(lt => (
                    <option key={lt}>{lt}</option>
                  ))}
                </Form.Control>
              )}
            </Form.Group>
          </Form>
        )}
      </td>
    </tr>
  )
}
export default LocationTypeLink
